import React, { useState, useEffect } from "react";
// import blogs from "../../../Utils/blogs";
import { BottomLine } from "../..";
import { FaLaptopCode } from "react-icons/fa";
import { IoCodeSlashOutline } from "react-icons/io5";
import { MdOutlineHomeRepairService } from "react-icons/md";
import { VscServerProcess } from "react-icons/vsc";
import { AiOutlineCloudSync } from "react-icons/ai";
import { GiPc } from "react-icons/gi";

import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import {
  headingAnimation,
  sectionBodyAnimation,
} from "../../../hooks/useAnimation";

const Experience = () => {
  //   const [currentPage] = useState(1);
  //   const [blogsPerPage] = useState(3);
  const [ref, inView] = useInView();
  const [viewDiv, setViewDiv] = useState(false);
  const animation = useAnimation();
  //   const indexOfLastBlog = currentPage * blogsPerPage;
  //   const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  //   const currentBlogs = blogs
  //     .sort((a, b) => new Date(b.date) - new Date(a.date))
  //     .slice(indexOfFirstBlog, indexOfLastBlog);

  useEffect(() => {
    if (inView) {
      setViewDiv(true);
    } else {
      setViewDiv(false);
    }
  }, [inView, animation]);

  const experiencesList = [
    {
      id: 1,
      role: "Mern Developer",
      icon: <FaLaptopCode />,
      company: "FreeLancer",
      place: "Online",
      description:
        "Implementing web development projects that suit clients’ aspirations and sharpen my knowledge of the technologies I possess.",
      start: "08/2023",
      end: "Present",
    },
    {
      id: 2,
      role: "Full Stack Developer",
      icon: <VscServerProcess />,
      company: "FreeLancer",
      place: "Online",
      description:
        "Building Jobify Web Application. This app allows users to track the status of their job applications.",
      start: "01/2024",
      end: "02/2024",
    },
    {
      id: 3,
      role: "Software Engineer Intern",
      icon: <AiOutlineCloudSync />,
      company: "Albonian Almarsos",
      place: "Online",
      description:
        "I signed up for this internship to sharpen my web development skills and build them on a strong scientific background.",
      start: "12/2022",
      end: "08/2023",
    },
    {
      id: 4,
      role: "Web Developer",
      icon: <IoCodeSlashOutline />,
      company: "Louay Services Group",
      place: "Turkey",
      description:
        "Examine the sites to be dealt with and find the best and fastest algorithm for dealing.",
      start: "07/2020",
      end: "08/2022",
    },
    {
      id: 5,
      role: "Technical Support Specialist",
      icon: <MdOutlineHomeRepairService />,
      company: "Louay Services Group",
      place: "Turkey",
      description:
        "I was Maintaining devices and preparing the programs and technologies necessary for work events, Identifying and solving problems when they occur, Proposing new algorithms that increase the efficiency of working with the necessary sites and platforms.",
      start: "03/2019",
      end: "06/2020",
    },
    {
      id: 6,
      role: "Computer Technical Specialist",
      icon: <GiPc />,
      company: "Al-Huda Computer Services Center",
      place: "Damascus City",
      description:
        "Connecting Web Database to the server. Fixing All kinds of issue with related to database with database advanced operators.",
      start: "03/2012",
      end: "04/2017",
    },
  ];

  return (
    <div className=" parent py-20">
      <motion.div
        className="mb-12"
        initial="hidden"
        animate={viewDiv && "visible"}
        variants={headingAnimation}
      >
        <h3 className="text-center text-neutral">Previous Works</h3>
        <h1 className="text-4xl font-semibold text-center">
          My <span className="text-primary">Experiences</span>
        </h1>
        <BottomLine />
      </motion.div>

      <motion.div
        className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3"
        ref={ref}
        initial="hidden"
        animate={viewDiv && "visible"}
        variants={sectionBodyAnimation}
      >
        {experiencesList?.map((experience) => (
          <div
            key={experience.id}
            className={`${
              experience.id % 2 === 0
                ? "bg-accent shadow-lg"
                : "bg-[#313131] shadow-md"
            } rounded-lg p-6 hover:shadow-primary cursor-pointer duration-300`}
          >
            <div className="mb-4 text-center">
              <span className="inline-block text-5xl text-primary">
                {experience.icon}
              </span>
            </div>
            <h2 className="mb-0 text-2xl font-semibold text-center">
              {experience.role}
            </h2>
            <h3 className="mb-0 text-1xl font-semibold text-center">
              From {experience.start} To {experience.end}
            </h3>
            <h3 className="mb-2 text-1xl font-semibold text-center">
              {experience.company}
              {/* / {experience.place} */}
            </h3>

            {/* <p className="text-neutral">{experience.description}</p> */}
          </div>
        ))}
      </motion.div>
    </div>
  );
};

export default Experience;
